import { Check } from 'lucide-react';

export default function Checkbox({ checked, onChange, disabled }) {
  return (
    <button
      onClick={onChange}
      disabled={disabled}
      className={`
        relative w-4 h-4 rounded flex items-center justify-center shrink-0
        transition-all duration-200 border
        ${checked
          ? 'bg-gradient-to-br from-success to-emerald-500 border-success shadow-sm shadow-success/30'
          : 'bg-surface-elevated border-border hover:border-text-tertiary'
        }
        ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
      `}
    >
      {checked && (
        <Check
          size={10}
          className="text-white animate-scale"
          strokeWidth={3}
        />
      )}
    </button>
  );
}
